@reference "tailwindcss";

.icon:hover {
  @apply transition-colors;
  fill: gray;
}
